import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Home from "./pages/home.js"
import FreeTrial from './pages/freetrial.js';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route exact path="/" component={Home} />
          <Route path="/freetrial" component={FreeTrial} />
        </div>
      </Router>
    );
  }
}

export default App;
